var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-slider" }, [
    _c(
      "div",
      {
        ref: "swiper",
        staticClass: "swiper-container home-slider__slider-container"
      },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.entries, function(entry) {
            return _c("div", { staticClass: "swiper-slide" }, [
              _c("div", { staticClass: "home-slider__images" }, [
                _c("div", { staticClass: "home-slider__images--left" }, [
                  _c("picture", [
                    _c("source", {
                      attrs: {
                        media: "(max-width: 767px)",
                        srcset: entry.imageMobilLeft
                      }
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        media: "(min-width: 768px)",
                        srcset: entry.imageDesktopLeft
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "home-slider__image",
                      attrs: {
                        src: entry.imageDesktopLeft,
                        loading: "lazy",
                        alt: entry.headline
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                !_vm.isMobile
                  ? _c("div", { staticClass: "home-slider__images--right" }, [
                      _c("picture", [
                        _c("source", {
                          attrs: {
                            media: "(max-width: 767px)",
                            srcset: entry.imageMobilRight
                          }
                        }),
                        _vm._v(" "),
                        _c("source", {
                          attrs: {
                            media: "(min-width: 768px)",
                            srcset: entry.imageDesktopRight
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "home-slider__image",
                          attrs: {
                            src: entry.imageMobilRight,
                            loading: "lazy",
                            alt: entry.headline
                          }
                        })
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              !_vm.isMobile
                ? _c("div", { staticClass: "home-slider__content-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "home-slider__content",
                        style: "background-color: " + entry.dreieckFarbe
                      },
                      [
                        _c("div", { staticClass: "home-slider__content-txt" }, [
                          _c("div", {
                            staticClass: "home-slider__slider-headline",
                            style: "color: " + entry.dreieckTextFarbe,
                            domProps: { innerHTML: _vm._s(entry.headline) }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "home-slider__slider-subheadline",
                            style: "color: " + entry.dreieckTextFarbe,
                            domProps: { innerHTML: _vm._s(entry.text) }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "home-slider__slider-button",
                              style:
                                "background-color: " + entry.dreieckButtonFarbe,
                              attrs: {
                                href: entry.buttonUrl,
                                alt: entry.buttonText
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "home-slider__slider-button--hover-rect",
                                style:
                                  "background-color: " +
                                  entry.dreieckButtonFarbeHover
                              }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(entry.buttonText) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "home-slider-mobile__content-wrapper" },
                    [
                      _c(
                        "div",
                        { staticClass: "home-slider-mobile__background" },
                        [
                          _c("div", {
                            staticClass: "home-slider-mobile__background--left",
                            style: "background-color: " + entry.bannerFarbeLinks
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "home-slider-mobile__background--right",
                              style:
                                "background-color: " + entry.bannerFarbeRechts
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "home-slider-mobile__background--triangle",
                                style:
                                  "border-color: transparent transparent " +
                                  entry.bannerFarbeRechts +
                                  " transparent"
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "home-slider-mobile__content",
                          style: "background-color: " + entry.dreieckFarbe
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "home-slider-mobile__content-txt" },
                            [
                              _c("div", {
                                staticClass:
                                  "home-slider-mobile__slider-headline",
                                style: "color: #585858",
                                domProps: { innerHTML: _vm._s(entry.headline) }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "home-slider-mobile__slider-subheadline",
                                style: "color: " + entry.dreieckTextFarbe,
                                domProps: { innerHTML: _vm._s(entry.text) }
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "home-slider-mobile__slider-button",
                                  style:
                                    "background-color: " +
                                    entry.dreieckButtonFarbeMobil,
                                  attrs: {
                                    href: entry.buttonUrl,
                                    alt: entry.buttonText
                                  }
                                },
                                [_vm._v(_vm._s(entry.buttonText))]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ])
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "home-slider__pagination" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-slider__prev" }, [
      _c("i", {
        staticClass: "icon-left",
        staticStyle: { "font-size": "20px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-slider__next" }, [
      _c("i", {
        staticClass: "icon-right",
        staticStyle: { "font-size": "20px" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }